// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2995":"css/app.6991","9864":"css/admin-app.6991"}[chunkId] + ".css";
};